export default __webpack_public_path__ + "static/media/section1-item-4.f3c362a6.png";